/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppSetting } from '../../models/app-setting';
import { UpdateSettingDto } from '../../models/update-setting-dto';

export interface AppSettingsControllerUpdate$Params {
  key: string;
      body: UpdateSettingDto
}

export function appSettingsControllerUpdate(http: HttpClient, rootUrl: string, params: AppSettingsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AppSetting>> {
  const rb = new RequestBuilder(rootUrl, appSettingsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('key', params.key, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppSetting>;
    })
  );
}

appSettingsControllerUpdate.PATH = '/settings/{key}';
